import "../chunk-7B52C2XE.js";
var OnRampMethod = /* @__PURE__ */ ((OnRampMethod2) => {
  OnRampMethod2["ACH"] = "ACH";
  OnRampMethod2["DEBIT"] = "Debit";
  OnRampMethod2["CREDIT"] = "Credit";
  OnRampMethod2["APPLE_PAY"] = "Apple Pay";
  return OnRampMethod2;
})(OnRampMethod || {});
export {
  OnRampMethod
};
